import React, { InputHTMLAttributes } from 'react';
import classNames from 'classnames';

import './ToggleSwitch.css';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  checked: boolean;
  name: string;
  onChange: () => void;
}

const ToggleSwitch = ({
  onChange,
  checked,
  name,
  disabled,
  readOnly,
}: Props) => {
  return (
    // prevents the AvatarMenu to be closed
    <div
      onClickCapture={e => {
        e.stopPropagation();
        onChange();
      }}
    >
      <label className={classNames({ 'cursor-not-allowed': disabled })}>
        <input
          name={name}
          id={name}
          type="checkbox"
          data-testid="toggle-switch"
          aria-label={name}
          className={classNames('track')}
          checked={checked}
          disabled={disabled}
          readOnly={readOnly}
        />
        <span className={classNames('thumb')}></span>
      </label>
    </div>
  );
};

export default ToggleSwitch;
